const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 382.2,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.225,
    cy: 256.848,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 369.175,
    cy: 254.232,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 369.175,
    cy: 245.768,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.225,
    cy: 243.152,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 389.4,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.65,
    cy: 258.464,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.45,
    cy: 263.695,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.55,
    cy: 263.695,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.35,
    cy: 258.464,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 360.6,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.35,
    cy: 241.536,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.55,
    cy: 236.305,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.45,
    cy: 236.305,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.65,
    cy: 241.536,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 396.6,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 394.733,
    cy: 258.786,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 389.453,
    cy: 266.052,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.675,
    cy: 270.543,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.742,
    cy: 271.482,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 364.2,
    cy: 268.706,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 357.525,
    cy: 262.696,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 353.872,
    cy: 254.491,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 353.872,
    cy: 245.509,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 357.525,
    cy: 237.304,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 364.2,
    cy: 231.294,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.742,
    cy: 228.518,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.675,
    cy: 229.457,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 389.453,
    cy: 233.948,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 394.733,
    cy: 241.214,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 403.8,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 402.39,
    cy: 258.9,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 398.3,
    cy: 266.928,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 391.928,
    cy: 273.3,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 383.9,
    cy: 277.39,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 278.8,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 366.1,
    cy: 277.39,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 358.072,
    cy: 273.3,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 351.7,
    cy: 266.928,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 347.61,
    cy: 258.9,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 346.2,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 347.61,
    cy: 241.1,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 351.7,
    cy: 233.072,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 358.072,
    cy: 226.7,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 366.1,
    cy: 222.61,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 221.2,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 391.928,
    cy: 226.7,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 398.3,
    cy: 233.072,
    r: 0.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 402.39,
    cy: 241.1,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 411,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 409.869,
    cy: 258.953,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.547,
    cy: 267.343,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 401.243,
    cy: 274.644,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 394.29,
    cy: 280.396,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.125,
    cy: 284.238,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.26,
    cy: 285.929,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 368.254,
    cy: 285.362,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 359.672,
    cy: 282.574,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 352.053,
    cy: 277.738,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 345.875,
    cy: 271.16,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 341.528,
    cy: 263.252,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 339.284,
    cy: 254.512,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 339.284,
    cy: 245.488,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 341.528,
    cy: 236.748,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 345.875,
    cy: 228.84,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 352.053,
    cy: 222.262,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 359.672,
    cy: 217.426,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 368.254,
    cy: 214.638,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.26,
    cy: 214.071,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.125,
    cy: 215.762,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 394.29,
    cy: 219.604,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.547,
    cy: 232.657,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 409.869,
    cy: 241.047,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 418.2,
    cy: 250,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 417.256,
    cy: 258.982,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 414.465,
    cy: 267.571,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 409.95,
    cy: 275.392,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 403.906,
    cy: 282.104,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 396.6,
    cy: 287.412,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.35,
    cy: 291.086,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.516,
    cy: 292.963,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.484,
    cy: 292.963,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 361.65,
    cy: 291.086,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 353.4,
    cy: 287.412,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 346.094,
    cy: 282.104,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 340.05,
    cy: 275.392,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 335.535,
    cy: 267.571,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 332.744,
    cy: 258.982,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 331.8,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 332.744,
    cy: 241.018,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 335.535,
    cy: 232.429,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 340.05,
    cy: 224.608,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 346.094,
    cy: 217.896,
    r: 0.339
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 361.65,
    cy: 208.914,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.484,
    cy: 207.037,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.516,
    cy: 207.037,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.35,
    cy: 208.914,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 396.6,
    cy: 212.588,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 403.906,
    cy: 217.896,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 409.95,
    cy: 224.608,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 414.465,
    cy: 232.429,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 417.256,
    cy: 241.018,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 425.4,
    cy: 250,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 424.59,
    cy: 258.999,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 422.186,
    cy: 267.709,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 418.266,
    cy: 275.85,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 412.955,
    cy: 283.16,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.424,
    cy: 289.404,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 398.883,
    cy: 294.382,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.574,
    cy: 297.933,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.765,
    cy: 299.944,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.739,
    cy: 300.349,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.785,
    cy: 299.136,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 355.192,
    cy: 296.344,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 347.235,
    cy: 292.063,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 340.17,
    cy: 286.429,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 334.226,
    cy: 279.624,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 329.591,
    cy: 271.868,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 326.416,
    cy: 263.408,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 324.803,
    cy: 254.518,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 324.803,
    cy: 245.482,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 326.416,
    cy: 236.592,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 329.591,
    cy: 228.132,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 334.226,
    cy: 220.376,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 340.17,
    cy: 213.571,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 347.235,
    cy: 207.938,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 355.192,
    cy: 203.656,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.785,
    cy: 200.864,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.739,
    cy: 199.651,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.765,
    cy: 200.056,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.574,
    cy: 202.067,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 398.883,
    cy: 205.618,
    r: 0.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.424,
    cy: 210.596,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 412.955,
    cy: 216.84,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 418.266,
    cy: 224.15,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 422.186,
    cy: 232.291,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 424.59,
    cy: 241.001,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 432.6,
    cy: 250,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 431.891,
    cy: 259.011,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 429.781,
    cy: 267.799,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 426.322,
    cy: 276.15,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 421.599,
    cy: 283.856,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.729,
    cy: 290.729,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 408.856,
    cy: 296.599,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 401.15,
    cy: 301.322,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 392.799,
    cy: 304.781,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.011,
    cy: 306.891,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 307.6,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 365.989,
    cy: 306.891,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 341.144,
    cy: 296.599,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 334.271,
    cy: 290.729,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 328.401,
    cy: 283.856,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 323.678,
    cy: 276.15,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 320.219,
    cy: 267.799,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 318.109,
    cy: 259.011,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 317.4,
    cy: 250,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 318.109,
    cy: 240.989,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 320.219,
    cy: 232.201,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 323.678,
    cy: 223.85,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 328.401,
    cy: 216.144,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 334.271,
    cy: 209.271,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 341.144,
    cy: 203.401,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 348.85,
    cy: 198.678,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 357.201,
    cy: 195.219,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 365.989,
    cy: 193.109,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 192.4,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.011,
    cy: 193.109,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 392.799,
    cy: 195.219,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 401.15,
    cy: 198.678,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 408.856,
    cy: 203.401,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.729,
    cy: 209.271,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 421.599,
    cy: 216.144,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 426.322,
    cy: 223.85,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 429.781,
    cy: 232.201,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 431.891,
    cy: 240.989,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 439.8,
    cy: 250,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 439.169,
    cy: 259.018,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 437.29,
    cy: 267.861,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 434.198,
    cy: 276.357,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 429.954,
    cy: 284.339,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 424.64,
    cy: 291.653,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 418.36,
    cy: 298.156,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 411.236,
    cy: 303.722,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 403.406,
    cy: 308.242,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 395.024,
    cy: 311.628,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.252,
    cy: 313.816,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.261,
    cy: 314.761,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 368.227,
    cy: 314.445,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 359.323,
    cy: 312.875,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 328.387,
    cy: 295.014,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 322.576,
    cy: 288.088,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 317.785,
    cy: 280.422,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 314.108,
    cy: 272.163,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 311.616,
    cy: 263.473,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 310.358,
    cy: 254.52,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 310.358,
    cy: 245.48,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 311.616,
    cy: 236.527,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 314.108,
    cy: 227.837,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 317.785,
    cy: 219.578,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 322.576,
    cy: 211.912,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 328.387,
    cy: 204.986,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 335.105,
    cy: 198.937,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 342.6,
    cy: 193.882,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 350.725,
    cy: 189.918,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 359.323,
    cy: 187.125,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 368.227,
    cy: 185.555,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.261,
    cy: 185.239,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.252,
    cy: 186.184,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 395.024,
    cy: 188.372,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 403.406,
    cy: 191.758,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 411.236,
    cy: 196.278,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 418.36,
    cy: 201.844,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 424.64,
    cy: 208.347,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 429.954,
    cy: 215.661,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 434.198,
    cy: 223.643,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 437.29,
    cy: 232.139,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 439.169,
    cy: 240.982,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 447,
    cy: 250,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 446.432,
    cy: 259.024,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.738,
    cy: 267.906,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 441.944,
    cy: 276.505,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 438.094,
    cy: 284.686,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 433.249,
    cy: 292.321,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 427.486,
    cy: 299.287,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 420.895,
    cy: 305.477,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 413.58,
    cy: 310.792,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 405.656,
    cy: 315.148,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 397.249,
    cy: 318.476,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.491,
    cy: 320.725,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.521,
    cy: 321.858,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.479,
    cy: 321.858,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 361.509,
    cy: 320.725,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 352.751,
    cy: 318.476,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 316.751,
    cy: 292.321,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 311.906,
    cy: 284.686,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 308.056,
    cy: 276.505,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 303.568,
    cy: 259.024,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 303,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 303.568,
    cy: 240.976,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 305.262,
    cy: 232.094,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 336.42,
    cy: 189.208,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 344.344,
    cy: 184.852,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 352.751,
    cy: 181.524,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 361.509,
    cy: 179.275,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.479,
    cy: 178.142,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.521,
    cy: 178.142,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.491,
    cy: 179.275,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 397.249,
    cy: 181.524,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 405.656,
    cy: 184.852,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 413.58,
    cy: 189.208,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 420.895,
    cy: 194.523,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 427.486,
    cy: 200.713,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 433.249,
    cy: 207.679,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 438.094,
    cy: 215.314,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 441.944,
    cy: 223.495,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.738,
    cy: 232.094,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 446.432,
    cy: 240.976,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 454.2,
    cy: 250,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 453.684,
    cy: 259.028,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 452.142,
    cy: 267.939,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.594,
    cy: 276.615,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 446.074,
    cy: 284.945,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 441.627,
    cy: 292.819,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 436.312,
    cy: 300.135,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 430.197,
    cy: 306.797,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 423.363,
    cy: 312.719,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.899,
    cy: 317.823,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 407.901,
    cy: 322.043,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 399.474,
    cy: 325.324,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.728,
    cy: 327.623,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.778,
    cy: 328.909,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.738,
    cy: 329.168,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.729,
    cy: 328.394,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 354.866,
    cy: 326.598,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 346.266,
    cy: 323.804,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 296.96,
    cy: 263.505,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 295.929,
    cy: 254.521,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 295.929,
    cy: 245.479,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 296.96,
    cy: 236.495,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 330.296,
    cy: 184.623,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 338.04,
    cy: 179.953,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 346.266,
    cy: 176.196,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 354.866,
    cy: 173.402,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.729,
    cy: 171.606,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.738,
    cy: 170.832,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.778,
    cy: 171.091,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.728,
    cy: 172.377,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 399.474,
    cy: 174.676,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 407.901,
    cy: 177.957,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.899,
    cy: 182.177,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 423.363,
    cy: 187.281,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 430.197,
    cy: 193.203,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 436.312,
    cy: 199.865,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 441.627,
    cy: 207.181,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 446.074,
    cy: 215.055,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.594,
    cy: 223.385,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 452.142,
    cy: 232.061,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 453.684,
    cy: 240.972,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 461.4,
    cy: 250,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 460.927,
    cy: 259.031,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.512,
    cy: 267.964,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 457.171,
    cy: 276.699,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 453.93,
    cy: 285.142,
    r: 0.679
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.825,
    cy: 293.2,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.899,
    cy: 300.785,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 439.208,
    cy: 307.813,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 432.813,
    cy: 314.208,
    r: 0.799
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 425.785,
    cy: 319.899,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 418.2,
    cy: 324.825,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 410.142,
    cy: 328.93,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 401.699,
    cy: 332.171,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 392.964,
    cy: 334.512,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.031,
    cy: 335.927,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 336.4,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 357.036,
    cy: 334.512,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 348.301,
    cy: 332.171,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 339.858,
    cy: 328.93,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 290.488,
    cy: 267.964,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 289.073,
    cy: 259.031,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 288.6,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 324.215,
    cy: 180.101,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 331.8,
    cy: 175.175,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 339.858,
    cy: 171.07,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 357.036,
    cy: 165.488,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 365.969,
    cy: 164.073,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 163.6,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.031,
    cy: 164.073,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 392.964,
    cy: 165.488,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 401.699,
    cy: 167.829,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 410.142,
    cy: 171.07,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 418.2,
    cy: 175.175,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 425.785,
    cy: 180.101,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 432.813,
    cy: 185.792,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 439.208,
    cy: 192.187,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.899,
    cy: 199.215,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.825,
    cy: 206.8,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 453.93,
    cy: 214.858,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 457.171,
    cy: 223.301,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.512,
    cy: 232.036,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 460.927,
    cy: 240.969,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 468.6,
    cy: 250,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 468.163,
    cy: 259.034,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 435.357,
    cy: 321.54,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 428.171,
    cy: 327.031,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 420.488,
    cy: 331.803,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 412.381,
    cy: 335.812,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 403.924,
    cy: 339.019,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 395.197,
    cy: 341.395,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.282,
    cy: 342.918,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.262,
    cy: 343.573,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 350.411,
    cy: 340.312,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 341.809,
    cy: 337.518,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 333.517,
    cy: 333.906,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 284.12,
    cy: 272.4,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 282.382,
    cy: 263.524,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 281.509,
    cy: 254.522,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 325.613,
    cy: 170.49,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 333.517,
    cy: 166.094,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 341.809,
    cy: 162.482,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 359.242,
    cy: 157.736,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 368.22,
    cy: 156.646,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.262,
    cy: 156.427,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.282,
    cy: 157.082,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 395.197,
    cy: 158.605,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 403.924,
    cy: 160.981,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 412.381,
    cy: 164.188,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 420.488,
    cy: 168.197,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 428.171,
    cy: 172.969,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 435.357,
    cy: 178.46,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 441.98,
    cy: 184.619,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 447.978,
    cy: 191.389,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 453.294,
    cy: 198.706,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 457.879,
    cy: 206.502,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 461.69,
    cy: 214.704,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 464.692,
    cy: 223.235,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 466.856,
    cy: 232.017,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 468.163,
    cy: 240.966,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 437.848,
    cy: 328.809,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 430.53,
    cy: 334.125,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 422.766,
    cy: 338.764,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 414.617,
    cy: 342.688,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.149,
    cy: 345.866,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 397.43,
    cy: 348.273,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.531,
    cy: 349.888,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.522,
    cy: 350.698,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 343.851,
    cy: 345.866,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 335.383,
    cy: 342.688,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 277.833,
    cy: 276.817,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 275.82,
    cy: 267.999,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 274.606,
    cy: 259.036,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 335.383,
    cy: 157.312,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 352.57,
    cy: 151.727,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 361.469,
    cy: 150.112,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.478,
    cy: 149.301,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.522,
    cy: 149.301,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.531,
    cy: 150.112,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 397.43,
    cy: 151.727,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.149,
    cy: 154.133,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 414.617,
    cy: 157.312,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 422.766,
    cy: 161.236,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 430.53,
    cy: 165.875,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 437.848,
    cy: 171.191,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.659,
    cy: 177.142,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 450.91,
    cy: 183.68,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 456.549,
    cy: 190.751,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 461.532,
    cy: 198.3,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 465.818,
    cy: 206.265,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 469.372,
    cy: 214.581,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 472.167,
    cy: 223.183,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 474.18,
    cy: 232.001,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 475.394,
    cy: 240.964,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 483,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 440.297,
    cy: 336.025,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 432.869,
    cy: 341.187,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 425.036,
    cy: 345.71,
    r: 0.799
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 416.852,
    cy: 349.561,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 408.374,
    cy: 352.714,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 399.662,
    cy: 355.147,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.777,
    cy: 356.841,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.781,
    cy: 357.787,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 337.354,
    cy: 351.226,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 329.016,
    cy: 347.721,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 271.609,
    cy: 281.215,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 269.36,
    cy: 272.454,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 354.763,
    cy: 143.913,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.711,
    cy: 142.592,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.738,
    cy: 142.024,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.781,
    cy: 142.213,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.777,
    cy: 143.159,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 399.662,
    cy: 144.853,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 408.374,
    cy: 147.286,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 416.852,
    cy: 150.439,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 425.036,
    cy: 154.29,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 432.869,
    cy: 158.813,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 440.297,
    cy: 163.975,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 447.266,
    cy: 169.74,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 453.729,
    cy: 176.069,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.639,
    cy: 182.916,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 464.956,
    cy: 190.234,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 469.641,
    cy: 197.971,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 473.663,
    cy: 206.072,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 476.993,
    cy: 214.482,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 479.607,
    cy: 223.141,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 481.488,
    cy: 231.989,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 482.621,
    cy: 240.963,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 490.2,
    cy: 250,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 456.459,
    cy: 331.459,
    r: 0.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.816,
    cy: 337.599,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 442.713,
    cy: 343.199,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 427.3,
    cy: 352.644,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 419.085,
    cy: 356.431,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 410.599,
    cy: 359.562,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 401.893,
    cy: 362.017,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 393.021,
    cy: 363.782,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.038,
    cy: 364.845,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 330.915,
    cy: 356.431,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 322.7,
    cy: 352.644,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 268.569,
    cy: 294.085,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 265.438,
    cy: 285.599,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 262.983,
    cy: 276.893,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 365.962,
    cy: 135.155,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 134.8,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.038,
    cy: 135.155,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 393.021,
    cy: 136.218,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 401.893,
    cy: 137.983,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 410.599,
    cy: 140.438,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 419.085,
    cy: 143.569,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 427.3,
    cy: 147.356,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 435.192,
    cy: 151.776,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 442.713,
    cy: 156.801,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.816,
    cy: 162.401,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 456.459,
    cy: 168.541,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 462.599,
    cy: 175.184,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 468.199,
    cy: 182.287,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 473.224,
    cy: 189.808,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 477.644,
    cy: 197.7,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 481.431,
    cy: 205.915,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 484.562,
    cy: 214.401,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 487.017,
    cy: 223.107,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 488.782,
    cy: 231.979,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 489.845,
    cy: 240.962,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 497.4,
    cy: 250,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 497.066,
    cy: 259.04,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.118,
    cy: 338.915,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 452.321,
    cy: 344.885,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 445.103,
    cy: 350.336,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 421.318,
    cy: 363.298,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 412.824,
    cy: 366.409,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 404.123,
    cy: 368.885,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 395.264,
    cy: 370.711,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.294,
    cy: 371.878,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 324.528,
    cy: 361.509,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 316.43,
    cy: 357.477,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 262.577,
    cy: 298.403,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 259.31,
    cy: 289.968,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 256.674,
    cy: 281.315,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 308.653,
    cy: 147.142,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 316.43,
    cy: 142.523,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 324.528,
    cy: 138.491,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 368.218,
    cy: 127.788,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 377.262,
    cy: 127.621,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 386.294,
    cy: 128.122,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 395.264,
    cy: 129.289,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 404.123,
    cy: 131.115,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 412.824,
    cy: 133.591,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 421.318,
    cy: 136.702,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 429.558,
    cy: 140.432,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 437.501,
    cy: 144.76,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 445.103,
    cy: 149.664,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 452.321,
    cy: 155.115,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.118,
    cy: 161.085,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 465.455,
    cy: 167.54,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 471.298,
    cy: 174.445,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 476.615,
    cy: 181.763,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 481.376,
    cy: 189.454,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 485.557,
    cy: 197.476,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 489.135,
    cy: 205.784,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 492.088,
    cy: 214.334,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 494.403,
    cy: 223.079,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 496.065,
    cy: 231.97,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 497.066,
    cy: 240.96,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 504.6,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 504.284,
    cy: 259.04,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 503.339,
    cy: 268.037,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 468.226,
    cy: 340.028,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 461.719,
    cy: 346.312,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 454.79,
    cy: 352.126,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 447.471,
    cy: 357.443,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 439.8,
    cy: 362.237,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 431.813,
    cy: 366.484,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.049,
    cy: 373.257,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.353,
    cy: 375.75,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 397.505,
    cy: 377.631,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.547,
    cy: 378.89,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 326.451,
    cy: 370.163,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 318.187,
    cy: 366.484,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 310.2,
    cy: 362.237,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 270.151,
    cy: 326.177,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 265.093,
    cy: 318.678,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 253.216,
    cy: 294.326,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 250.42,
    cy: 285.723,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 302.529,
    cy: 142.557,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 310.2,
    cy: 137.763,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 318.187,
    cy: 133.516,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.477,
    cy: 120.479,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.523,
    cy: 120.479,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 388.547,
    cy: 121.11,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 397.505,
    cy: 122.369,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.353,
    cy: 124.25,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.049,
    cy: 126.743,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 423.549,
    cy: 129.837,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 431.813,
    cy: 133.516,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 439.8,
    cy: 137.763,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 447.471,
    cy: 142.557,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 454.79,
    cy: 147.874,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 461.719,
    cy: 153.688,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 468.226,
    cy: 159.972,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 474.279,
    cy: 166.695,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 479.849,
    cy: 173.823,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 484.907,
    cy: 181.322,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 489.43,
    cy: 189.156,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 493.395,
    cy: 197.287,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 496.784,
    cy: 205.674,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 499.58,
    cy: 214.277,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 501.768,
    cy: 223.055,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 503.339,
    cy: 231.963,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 504.284,
    cy: 240.96,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 511.8,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 511.501,
    cy: 259.041,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 510.605,
    cy: 268.043,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 509.116,
    cy: 276.966,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 477.165,
    cy: 340.975,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 464.274,
    cy: 353.655,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 457.228,
    cy: 359.329,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.823,
    cy: 364.524,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 442.09,
    cy: 369.219,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 434.064,
    cy: 373.392,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 425.78,
    cy: 377.026,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 320.048,
    cy: 375.278,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 311.889,
    cy: 371.372,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 304.005,
    cy: 366.936,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 269.883,
    cy: 337.548,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 264.326,
    cy: 330.409,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 259.254,
    cy: 322.919,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 254.688,
    cy: 315.11,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 289.202,
    cy: 143.45,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 296.432,
    cy: 138.012,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 304.005,
    cy: 133.064,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 311.889,
    cy: 128.628,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.783,
    cy: 113.368,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.798,
    cy: 114.115,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 399.744,
    cy: 115.457,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 408.582,
    cy: 117.386,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 417.274,
    cy: 119.895,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 425.78,
    cy: 122.974,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 434.064,
    cy: 126.608,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 442.09,
    cy: 130.781,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.823,
    cy: 135.476,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 457.228,
    cy: 140.671,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 464.274,
    cy: 146.345,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 470.929,
    cy: 152.471,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 477.165,
    cy: 159.025,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 482.954,
    cy: 165.976,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 488.272,
    cy: 173.294,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 493.093,
    cy: 180.948,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 497.399,
    cy: 188.904,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 501.169,
    cy: 197.127,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 504.388,
    cy: 205.581,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 507.041,
    cy: 214.23,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 509.116,
    cy: 223.034,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 510.605,
    cy: 231.957,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 511.501,
    cy: 240.959,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 519,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 518.716,
    cy: 259.042,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 517.865,
    cy: 268.048,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 516.449,
    cy: 276.983,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 514.476,
    cy: 285.811,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 511.952,
    cy: 294.498,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 479.971,
    cy: 348.575,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 473.575,
    cy: 354.971,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 466.789,
    cy: 360.954,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.641,
    cy: 366.498,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 452.159,
    cy: 371.583,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.373,
    cy: 376.188,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 436.312,
    cy: 380.295,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 419.498,
    cy: 386.952,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 410.811,
    cy: 389.476,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 313.688,
    cy: 380.295,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 305.627,
    cy: 376.188,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 297.841,
    cy: 371.583,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 264.046,
    cy: 341.789,
    r: 0.339
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 258.502,
    cy: 334.641,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 253.417,
    cy: 327.159,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 248.812,
    cy: 319.373,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 244.705,
    cy: 311.312,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 241.112,
    cy: 303.01,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 241.112,
    cy: 196.99,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 244.705,
    cy: 188.688,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 264.046,
    cy: 158.211,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 270.029,
    cy: 151.425,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 276.425,
    cy: 145.029,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 283.211,
    cy: 139.046,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 290.359,
    cy: 133.502,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 297.841,
    cy: 128.417,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 305.627,
    cy: 123.812,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 313.688,
    cy: 119.705,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 321.99,
    cy: 116.112,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 428.01,
    cy: 116.112,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 436.312,
    cy: 119.705,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.373,
    cy: 123.812,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 452.159,
    cy: 128.417,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.641,
    cy: 133.502,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 466.789,
    cy: 139.046,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 473.575,
    cy: 145.029,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 479.971,
    cy: 151.425,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 485.954,
    cy: 158.211,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 491.498,
    cy: 165.359,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 496.583,
    cy: 172.841,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 501.188,
    cy: 180.627,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 505.295,
    cy: 188.688,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 508.888,
    cy: 196.99,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 511.952,
    cy: 205.502,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 514.476,
    cy: 214.189,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 516.449,
    cy: 223.017,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 517.865,
    cy: 231.952,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 518.716,
    cy: 240.958,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 526.2,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 525.929,
    cy: 259.042,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 523.77,
    cy: 276.998,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 521.889,
    cy: 285.847,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 519.483,
    cy: 294.567,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 516.559,
    cy: 303.128,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 446.649,
    cy: 383.146,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 438.558,
    cy: 387.193,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 430.24,
    cy: 390.748,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 421.723,
    cy: 393.8,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 413.04,
    cy: 396.337,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 404.22,
    cy: 398.35,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 307.366,
    cy: 385.23,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 299.4,
    cy: 380.943,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 291.704,
    cy: 376.187,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 264.163,
    cy: 352.842,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 258.211,
    cy: 346.03,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 252.677,
    cy: 338.873,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 247.581,
    cy: 331.399,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 242.941,
    cy: 323.633,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 238.774,
    cy: 315.603,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 235.094,
    cy: 307.339,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 231.915,
    cy: 298.869,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 231.915,
    cy: 201.131,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 235.094,
    cy: 192.661,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 238.774,
    cy: 184.397,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 242.941,
    cy: 176.367,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 258.211,
    cy: 153.97,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 264.163,
    cy: 147.158,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 270.511,
    cy: 140.713,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 277.234,
    cy: 134.66,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 284.307,
    cy: 129.02,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 291.704,
    cy: 123.813,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 299.4,
    cy: 119.057,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 307.366,
    cy: 114.77,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 315.575,
    cy: 110.967,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 323.996,
    cy: 107.662,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 430.24,
    cy: 109.252,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 438.558,
    cy: 112.807,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 446.649,
    cy: 116.854,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 454.483,
    cy: 121.377,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 462.033,
    cy: 126.361,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 469.272,
    cy: 131.787,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 476.173,
    cy: 137.637,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 482.711,
    cy: 143.888,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 488.864,
    cy: 150.52,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 494.61,
    cy: 157.507,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 499.927,
    cy: 164.826,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 504.797,
    cy: 172.45,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 509.203,
    cy: 180.351,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 513.128,
    cy: 188.501,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 516.559,
    cy: 196.872,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 519.483,
    cy: 205.433,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 521.889,
    cy: 214.153,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 523.77,
    cy: 223.002,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 525.118,
    cy: 231.948,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 525.929,
    cy: 240.958,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 533.4,
    cy: 250,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 531.08,
    cy: 277.011,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 529.284,
    cy: 285.877,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 526.984,
    cy: 294.626,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 524.188,
    cy: 303.23,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 432.469,
    cy: 397.607,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 423.948,
    cy: 400.647,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.268,
    cy: 403.196,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.457,
    cy: 405.245,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 397.543,
    cy: 406.788,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 301.08,
    cy: 390.094,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 293.203,
    cy: 385.646,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 285.592,
    cy: 380.755,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 258.3,
    cy: 357.106,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 252.376,
    cy: 350.269,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 246.852,
    cy: 343.105,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 241.745,
    cy: 335.638,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 237.074,
    cy: 327.891,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 232.852,
    cy: 319.889,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.094,
    cy: 311.66,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 225.812,
    cy: 303.23,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.016,
    cy: 294.626,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.016,
    cy: 205.374,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 225.812,
    cy: 196.77,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.094,
    cy: 188.34,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 232.852,
    cy: 180.111,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 237.074,
    cy: 172.11,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 252.376,
    cy: 149.731,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 258.3,
    cy: 142.894,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 264.605,
    cy: 136.406,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 271.27,
    cy: 130.289,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 278.273,
    cy: 124.563,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 285.592,
    cy: 119.245,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 293.203,
    cy: 114.354,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 301.08,
    cy: 109.906,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 309.198,
    cy: 105.914,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 317.531,
    cy: 102.393,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 326.052,
    cy: 99.353,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 334.732,
    cy: 96.804,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 343.543,
    cy: 94.755,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.477,
    cy: 91.665,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 379.523,
    cy: 91.665,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 440.802,
    cy: 105.914,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 448.92,
    cy: 109.906,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 456.797,
    cy: 114.354,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 464.408,
    cy: 119.245,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 471.727,
    cy: 124.563,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 478.73,
    cy: 130.289,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 485.395,
    cy: 136.406,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 491.7,
    cy: 142.894,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 497.624,
    cy: 149.731,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 503.148,
    cy: 156.895,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 508.255,
    cy: 164.362,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 512.926,
    cy: 172.11,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 517.148,
    cy: 180.111,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 520.906,
    cy: 188.34,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 524.188,
    cy: 196.77,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 526.984,
    cy: 205.374,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 529.284,
    cy: 214.123,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 531.08,
    cy: 222.989,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 532.367,
    cy: 231.944,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 533.142,
    cy: 240.957,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 540.6,
    cy: 250,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 540.353,
    cy: 259.043,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 539.612,
    cy: 268.06,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 538.38,
    cy: 277.022,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 536.661,
    cy: 285.904,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 534.459,
    cy: 294.678,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 417.496,
    cy: 410.054,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 408.692,
    cy: 412.136,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 399.788,
    cy: 413.734,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.81,
    cy: 414.844,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 294.825,
    cy: 394.898,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 287.032,
    cy: 390.303,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 252.441,
    cy: 361.367,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 246.542,
    cy: 354.508,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 241.027,
    cy: 347.337,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 235.911,
    cy: 339.876,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 231.211,
    cy: 332.146,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 226.939,
    cy: 324.171,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.11,
    cy: 315.975,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 219.734,
    cy: 307.582,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 216.821,
    cy: 299.017,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 214.38,
    cy: 290.306,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 210.942,
    cy: 272.549,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 212.419,
    cy: 218.525,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 214.38,
    cy: 209.694,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 216.821,
    cy: 200.983,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 219.734,
    cy: 192.418,
    r: 0.799
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.11,
    cy: 184.025,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 226.939,
    cy: 175.829,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 231.211,
    cy: 167.854,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 252.441,
    cy: 138.633,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 258.706,
    cy: 132.106,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 265.317,
    cy: 125.931,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 272.256,
    cy: 120.127,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 279.502,
    cy: 114.71,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 287.032,
    cy: 109.697,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 294.825,
    cy: 105.102,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 302.858,
    cy: 100.94,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 311.106,
    cy: 97.223,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 319.544,
    cy: 93.962,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 328.148,
    cy: 91.166,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 336.892,
    cy: 88.844,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 345.749,
    cy: 87.004,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.699,
    cy: 84.786,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 372.738,
    cy: 84.415,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 381.784,
    cy: 84.539,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 390.81,
    cy: 85.156,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 443.044,
    cy: 99.025,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 451.187,
    cy: 102.966,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.102,
    cy: 107.346,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 466.767,
    cy: 112.152,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 474.158,
    cy: 117.369,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 481.253,
    cy: 122.982,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 488.031,
    cy: 128.974,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 494.471,
    cy: 135.327,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 500.555,
    cy: 142.022,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 506.264,
    cy: 149.04,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 511.582,
    cy: 156.359,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 516.492,
    cy: 163.957,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 520.979,
    cy: 171.812,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 525.031,
    cy: 179.901,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 528.636,
    cy: 188.198,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 531.781,
    cy: 196.68,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 534.459,
    cy: 205.322,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 536.661,
    cy: 214.096,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 538.38,
    cy: 222.978,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 539.612,
    cy: 231.94,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 540.353,
    cy: 240.957,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 547.8,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 547.563,
    cy: 259.044,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 546.853,
    cy: 268.063,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 545.673,
    cy: 277.032,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 544.024,
    cy: 285.927,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 410.927,
    cy: 419.024,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 402.032,
    cy: 420.673,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 393.063,
    cy: 421.853,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.044,
    cy: 422.563,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 246.585,
    cy: 365.626,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 240.709,
    cy: 358.747,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 235.202,
    cy: 351.569,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 230.078,
    cy: 344.114,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 225.351,
    cy: 336.4,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 221.034,
    cy: 328.45,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.139,
    cy: 320.284,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 213.677,
    cy: 311.926,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 210.657,
    cy: 303.398,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 208.088,
    cy: 294.724,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.976,
    cy: 285.927,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 203.147,
    cy: 268.063,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 204.327,
    cy: 222.968,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.976,
    cy: 214.073,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 208.088,
    cy: 205.276,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 210.657,
    cy: 196.602,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 213.677,
    cy: 188.074,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.139,
    cy: 179.716,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 221.034,
    cy: 171.55,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 225.351,
    cy: 163.6,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 230.078,
    cy: 155.886,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 246.585,
    cy: 134.374,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 252.812,
    cy: 127.812,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 259.374,
    cy: 121.585,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 266.253,
    cy: 115.709,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 273.431,
    cy: 110.202,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 280.886,
    cy: 105.078,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 288.6,
    cy: 100.351,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 296.55,
    cy: 96.034,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 304.716,
    cy: 92.139,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 313.074,
    cy: 88.677,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 321.602,
    cy: 85.657,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 330.276,
    cy: 83.088,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 339.073,
    cy: 80.976,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 347.968,
    cy: 79.327,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 356.937,
    cy: 78.147,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 375,
    cy: 77.2,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 384.044,
    cy: 77.437,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 393.063,
    cy: 78.147,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 445.284,
    cy: 92.139,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 453.45,
    cy: 96.034,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 461.4,
    cy: 100.351,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 469.114,
    cy: 105.078,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 476.569,
    cy: 110.202,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 483.747,
    cy: 115.709,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 490.626,
    cy: 121.585,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 497.188,
    cy: 127.812,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 503.415,
    cy: 134.374,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 509.291,
    cy: 141.253,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 514.798,
    cy: 148.431,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 519.922,
    cy: 155.886,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 524.649,
    cy: 163.6,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 528.966,
    cy: 171.55,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 532.861,
    cy: 179.716,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 536.323,
    cy: 188.074,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 539.343,
    cy: 196.602,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 541.912,
    cy: 205.276,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 544.024,
    cy: 214.073,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 545.673,
    cy: 222.968,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 546.853,
    cy: 231.937,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 547.563,
    cy: 240.956,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 555,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 554.773,
    cy: 259.044,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 554.091,
    cy: 268.065,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 552.957,
    cy: 277.041,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 551.374,
    cy: 285.948,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 395.314,
    cy: 428.85,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 240.731,
    cy: 369.882,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 234.877,
    cy: 362.984,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.377,
    cy: 355.801,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 224.245,
    cy: 348.351,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 219.494,
    cy: 340.652,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 215.135,
    cy: 332.724,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.181,
    cy: 324.588,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 207.64,
    cy: 316.262,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 204.522,
    cy: 307.77,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 201.835,
    cy: 299.131,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.585,
    cy: 290.369,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 196.419,
    cy: 272.56,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 196.419,
    cy: 227.44,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 197.778,
    cy: 218.496,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.585,
    cy: 209.631,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 201.835,
    cy: 200.869,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 204.522,
    cy: 192.23,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 207.64,
    cy: 183.738,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.181,
    cy: 175.412,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 215.135,
    cy: 167.276,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 219.494,
    cy: 159.348,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 224.245,
    cy: 151.649,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.377,
    cy: 144.199,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 234.877,
    cy: 137.016,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 246.924,
    cy: 123.523,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 253.44,
    cy: 117.248,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 260.264,
    cy: 111.308,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 267.377,
    cy: 105.718,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 274.762,
    cy: 100.493,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 282.401,
    cy: 95.645,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 290.273,
    cy: 91.188,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 298.36,
    cy: 87.131,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 306.64,
    cy: 83.486,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 315.092,
    cy: 80.262,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 323.697,
    cy: 77.466,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 332.43,
    cy: 75.106,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 341.271,
    cy: 73.188,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 350.198,
    cy: 71.717,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 359.187,
    cy: 70.696,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 368.216,
    cy: 70.128,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 430.623,
    cy: 78.81,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 455.709,
    cy: 89.109,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 463.691,
    cy: 93.367,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 471.449,
    cy: 98.021,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 478.963,
    cy: 103.059,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 486.215,
    cy: 108.468,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 493.185,
    cy: 114.235,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 499.858,
    cy: 120.344,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 506.214,
    cy: 126.782,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 512.24,
    cy: 133.53,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 517.918,
    cy: 140.573,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 523.236,
    cy: 147.892,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 528.179,
    cy: 155.469,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 532.735,
    cy: 163.284,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 536.893,
    cy: 171.319,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 540.642,
    cy: 179.553,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 543.972,
    cy: 187.964,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 546.876,
    cy: 196.533,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 549.345,
    cy: 205.236,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 551.374,
    cy: 214.052,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 552.957,
    cy: 222.959,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 554.091,
    cy: 231.935,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 554.773,
    cy: 240.956,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 562.2,
    cy: 250,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.981,
    cy: 259.044,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.326,
    cy: 268.067,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 560.236,
    cy: 277.048,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 558.712,
    cy: 285.966,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 556.76,
    cy: 294.8,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 241.04,
    cy: 380.761,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 234.879,
    cy: 374.137,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.045,
    cy: 367.222,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.552,
    cy: 360.033,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 218.413,
    cy: 352.588,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 213.639,
    cy: 344.903,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 209.243,
    cy: 336.996,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.233,
    cy: 328.886,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 201.62,
    cy: 320.592,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 198.412,
    cy: 312.133,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 195.616,
    cy: 303.529,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 193.24,
    cy: 294.8,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 191.288,
    cy: 285.966,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.674,
    cy: 268.067,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 187.8,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.019,
    cy: 240.956,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.674,
    cy: 231.933,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 189.764,
    cy: 222.952,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 191.288,
    cy: 214.034,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 193.24,
    cy: 205.2,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 195.616,
    cy: 196.471,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 198.412,
    cy: 187.867,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 201.62,
    cy: 179.408,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.233,
    cy: 171.114,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 209.243,
    cy: 163.004,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 213.639,
    cy: 155.097,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 218.413,
    cy: 147.412,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.552,
    cy: 139.967,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.045,
    cy: 132.778,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 234.879,
    cy: 125.863,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 247.514,
    cy: 112.919,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 254.286,
    cy: 106.92,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 261.339,
    cy: 101.255,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 268.658,
    cy: 95.937,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 276.226,
    cy: 90.98,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 284.024,
    cy: 86.393,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 292.035,
    cy: 82.189,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 300.239,
    cy: 78.377,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 308.618,
    cy: 74.965,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 317.152,
    cy: 71.962,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 352.436,
    cy: 64.165,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 370.477,
    cy: 62.855,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 441.382,
    cy: 74.965,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 449.761,
    cy: 78.377,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 465.976,
    cy: 86.393,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 488.661,
    cy: 101.255,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 495.714,
    cy: 106.92,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 502.486,
    cy: 112.919,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 508.96,
    cy: 119.239,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 515.121,
    cy: 125.863,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 520.955,
    cy: 132.778,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 526.448,
    cy: 139.967,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 531.587,
    cy: 147.412,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 536.361,
    cy: 155.097,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 540.757,
    cy: 163.004,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 544.767,
    cy: 171.114,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 548.38,
    cy: 179.408,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 551.588,
    cy: 187.867,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 554.384,
    cy: 196.471,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 556.76,
    cy: 205.2,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 558.712,
    cy: 214.034,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 560.236,
    cy: 222.952,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.326,
    cy: 231.933,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.981,
    cy: 240.956,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 569.4,
    cy: 250,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 569.19,
    cy: 259.045,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 568.558,
    cy: 268.069,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 567.508,
    cy: 277.055,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 566.041,
    cy: 285.982,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 564.16,
    cy: 294.832,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.869,
    cy: 303.584,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 235.16,
    cy: 385.042,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.029,
    cy: 378.389,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.214,
    cy: 371.459,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.727,
    cy: 364.265,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 212.581,
    cy: 356.825,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 207.787,
    cy: 349.152,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 203.355,
    cy: 341.265,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.295,
    cy: 333.181,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 195.615,
    cy: 324.916,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 192.324,
    cy: 316.489,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 189.428,
    cy: 307.918,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 186.934,
    cy: 299.221,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 184.848,
    cy: 290.418,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 181.914,
    cy: 272.568,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 181.074,
    cy: 263.561,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 180.653,
    cy: 254.523,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 180.653,
    cy: 245.477,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 181.074,
    cy: 236.439,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 181.914,
    cy: 227.432,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 183.174,
    cy: 218.473,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 184.848,
    cy: 209.582,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 186.934,
    cy: 200.779,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 189.428,
    cy: 192.082,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 192.324,
    cy: 183.511,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 195.615,
    cy: 175.084,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.295,
    cy: 166.819,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 203.355,
    cy: 158.735,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 207.787,
    cy: 150.848,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 212.581,
    cy: 143.175,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.727,
    cy: 135.735,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.214,
    cy: 128.541,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.029,
    cy: 121.611,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 248.318,
    cy: 102.545,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 255.315,
    cy: 96.811,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 262.572,
    cy: 91.408,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 270.072,
    cy: 86.349,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 277.8,
    cy: 81.645,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 285.738,
    cy: 77.305,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 293.869,
    cy: 73.339,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 302.176,
    cy: 69.755,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 310.641,
    cy: 66.563,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 354.68,
    cy: 56.665,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 363.697,
    cy: 55.929,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 451.998,
    cy: 71.499,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 491.088,
    cy: 94.067,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 498.217,
    cy: 99.637,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 505.079,
    cy: 105.533,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 511.66,
    cy: 111.741,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 517.944,
    cy: 118.249,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 523.919,
    cy: 125.042,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 529.571,
    cy: 132.106,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 534.889,
    cy: 139.425,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 539.861,
    cy: 146.984,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 544.475,
    cy: 154.765,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 548.722,
    cy: 162.753,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 552.593,
    cy: 170.93,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 556.08,
    cy: 179.279,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 559.174,
    cy: 187.78,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.869,
    cy: 196.416,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 564.16,
    cy: 205.168,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 566.041,
    cy: 214.018,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 567.508,
    cy: 222.945,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 568.558,
    cy: 231.931,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 569.19,
    cy: 240.955,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.6,
    cy: 250,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.397,
    cy: 259.045,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 575.788,
    cy: 268.071,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 574.775,
    cy: 277.061,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 573.36,
    cy: 285.997,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 571.545,
    cy: 294.86,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 569.335,
    cy: 303.633,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 229.285,
    cy: 389.318,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.181,
    cy: 382.64,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.383,
    cy: 375.696,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.902,
    cy: 368.497,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.75,
    cy: 361.061,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 201.937,
    cy: 353.4,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 197.472,
    cy: 345.532,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 193.365,
    cy: 337.471,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 189.623,
    cy: 329.234,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 186.255,
    cy: 320.837,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 183.267,
    cy: 312.298,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 180.665,
    cy: 303.633,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 178.455,
    cy: 294.86,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 173.603,
    cy: 259.045,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 173.4,
    cy: 250,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 173.603,
    cy: 240.955,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 174.212,
    cy: 231.929,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 175.225,
    cy: 222.939,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 176.64,
    cy: 214.003,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 178.455,
    cy: 205.14,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 180.665,
    cy: 196.367,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 183.267,
    cy: 187.702,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 186.255,
    cy: 179.163,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 189.623,
    cy: 170.766,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 197.472,
    cy: 154.468,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 201.937,
    cy: 146.6,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.75,
    cy: 138.939,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.902,
    cy: 131.502,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.383,
    cy: 124.304,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.181,
    cy: 117.36,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 242.36,
    cy: 98.181,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 249.304,
    cy: 92.383,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 256.503,
    cy: 86.902,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 263.939,
    cy: 81.75,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 271.6,
    cy: 76.937,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 279.468,
    cy: 72.472,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 287.529,
    cy: 68.365,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 295.766,
    cy: 64.623,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 500.696,
    cy: 92.383,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 507.64,
    cy: 98.181,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 514.318,
    cy: 104.285,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 520.715,
    cy: 110.682,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 526.819,
    cy: 117.36,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 532.617,
    cy: 124.304,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 538.098,
    cy: 131.502,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 543.25,
    cy: 138.939,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 548.063,
    cy: 146.6,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 552.528,
    cy: 154.468,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 556.635,
    cy: 162.529,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 560.377,
    cy: 170.766,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 563.745,
    cy: 179.163,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 566.733,
    cy: 187.702,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 569.335,
    cy: 196.367,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 571.545,
    cy: 205.14,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 573.36,
    cy: 214.003,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 574.775,
    cy: 222.939,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 575.788,
    cy: 231.929,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.397,
    cy: 240.955,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.8,
    cy: 250,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.604,
    cy: 259.045,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.016,
    cy: 268.073,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 582.038,
    cy: 277.067,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.783,
    cy: 303.677,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 574.268,
    cy: 312.368,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 223.412,
    cy: 393.592,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.334,
    cy: 386.89,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.552,
    cy: 379.932,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.077,
    cy: 372.73,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.919,
    cy: 365.297,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 196.088,
    cy: 357.648,
    r: 0.679
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 191.593,
    cy: 349.796,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 187.442,
    cy: 341.758,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 183.643,
    cy: 333.547,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 180.204,
    cy: 325.179,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 177.13,
    cy: 316.67,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 172.102,
    cy: 299.293,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 170.157,
    cy: 290.458,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 168.597,
    cy: 281.546,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 167.424,
    cy: 272.575,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 166.641,
    cy: 263.562,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 166.249,
    cy: 254.524,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 166.249,
    cy: 245.476,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 166.641,
    cy: 236.438,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 167.424,
    cy: 227.425,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 168.597,
    cy: 218.454,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 170.157,
    cy: 209.542,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 172.102,
    cy: 200.707,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 174.428,
    cy: 191.964,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 177.13,
    cy: 183.33,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 180.204,
    cy: 174.821,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 183.643,
    cy: 166.453,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 196.088,
    cy: 142.352,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.919,
    cy: 134.703,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.077,
    cy: 127.27,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.552,
    cy: 120.068,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.334,
    cy: 113.11,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 236.41,
    cy: 93.826,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 243.305,
    cy: 87.969,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 250.448,
    cy: 82.417,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 257.824,
    cy: 77.179,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 265.421,
    cy: 72.265,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 273.223,
    cy: 67.685,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 503.154,
    cy: 85.154,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 510.174,
    cy: 90.861,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 516.941,
    cy: 96.866,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 523.441,
    cy: 103.158,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 529.663,
    cy: 109.726,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 535.594,
    cy: 116.558,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 541.224,
    cy: 123.64,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 546.542,
    cy: 130.959,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 551.538,
    cy: 138.502,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 556.202,
    cy: 146.254,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 560.526,
    cy: 154.2,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 564.502,
    cy: 162.327,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 568.122,
    cy: 170.618,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 571.379,
    cy: 179.059,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 574.268,
    cy: 187.632,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.783,
    cy: 196.323,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 578.918,
    cy: 205.114,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 580.671,
    cy: 213.99,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 582.038,
    cy: 222.933,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.016,
    cy: 231.927,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.604,
    cy: 240.955,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 591,
    cy: 250,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 586.28,
    cy: 294.909,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 584.214,
    cy: 303.717,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 581.781,
    cy: 312.431,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 343.446,
    cy: 463.683,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 334.526,
    cy: 462.174,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.543,
    cy: 397.862,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.489,
    cy: 391.139,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.722,
    cy: 384.168,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.252,
    cy: 376.962,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 195.089,
    cy: 369.533,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 190.241,
    cy: 361.894,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 185.718,
    cy: 354.059,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 181.526,
    cy: 346.041,
    r: 0.339
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 177.674,
    cy: 337.855,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 174.168,
    cy: 329.515,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 171.015,
    cy: 321.035,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 163.72,
    cy: 294.909,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 162.025,
    cy: 286.022,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 160.703,
    cy: 277.072,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.758,
    cy: 268.074,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.189,
    cy: 259.045,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159,
    cy: 250,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.189,
    cy: 240.955,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.758,
    cy: 231.926,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 160.703,
    cy: 222.928,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 162.025,
    cy: 213.978,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 163.72,
    cy: 205.091,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 165.786,
    cy: 196.283,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 168.219,
    cy: 187.569,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 171.015,
    cy: 178.965,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 174.168,
    cy: 170.485,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 177.674,
    cy: 162.145,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 190.241,
    cy: 138.106,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 195.089,
    cy: 130.467,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.252,
    cy: 123.038,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.722,
    cy: 115.832,
    r: 0.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.489,
    cy: 108.861,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 230.468,
    cy: 89.481,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 237.316,
    cy: 83.569,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 244.407,
    cy: 77.95,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 251.726,
    cy: 72.632,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 259.261,
    cy: 67.625,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 505.593,
    cy: 77.95,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 512.684,
    cy: 83.569,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 519.532,
    cy: 89.481,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 526.127,
    cy: 95.674,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 532.457,
    cy: 102.138,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 538.511,
    cy: 108.861,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 544.278,
    cy: 115.832,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 549.748,
    cy: 123.038,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 554.911,
    cy: 130.467,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 559.759,
    cy: 138.106,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 564.282,
    cy: 145.941,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 568.474,
    cy: 153.959,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 572.326,
    cy: 162.145,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 575.832,
    cy: 170.485,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 578.985,
    cy: 178.965,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 581.781,
    cy: 187.569,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 584.214,
    cy: 196.283,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 586.28,
    cy: 205.091,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 587.975,
    cy: 213.978,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 589.297,
    cy: 222.928,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 590.242,
    cy: 231.926,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 590.811,
    cy: 240.955,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 598.2,
    cy: 250,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 595.272,
    cy: 286.033,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 593.631,
    cy: 294.93,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 591.631,
    cy: 303.753,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 589.274,
    cy: 312.488,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 558.194,
    cy: 377.507,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 552.877,
    cy: 384.826,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 547.267,
    cy: 391.924,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 493.065,
    cy: 439.417,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 345.68,
    cy: 471.266,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 336.737,
    cy: 469.896,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 327.857,
    cy: 468.165,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 245.643,
    cy: 431.893,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.676,
    cy: 402.13,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.645,
    cy: 395.386,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.892,
    cy: 388.404,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.427,
    cy: 381.194,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 184.396,
    cy: 366.139,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 154.043,
    cy: 281.561,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 152.945,
    cy: 272.581,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 152.212,
    cy: 263.563,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 151.846,
    cy: 245.476,
    r: 0.799
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 152.212,
    cy: 236.437,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 152.945,
    cy: 227.419,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 154.043,
    cy: 218.439,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 155.503,
    cy: 209.51,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 157.324,
    cy: 200.648,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.503,
    cy: 191.868,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 162.036,
    cy: 183.182,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 164.919,
    cy: 174.607,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 168.147,
    cy: 166.155,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 171.715,
    cy: 157.841,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 179.846,
    cy: 141.681,
    r: 0.339
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 184.396,
    cy: 133.861,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 189.259,
    cy: 126.232,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.427,
    cy: 118.806,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.892,
    cy: 111.596,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.645,
    cy: 104.614,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 211.676,
    cy: 97.87,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.976,
    cy: 91.376,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 224.533,
    cy: 85.143,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 231.337,
    cy: 79.181,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 238.378,
    cy: 73.499,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 245.643,
    cy: 68.107,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 508.017,
    cy: 70.766,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 515.171,
    cy: 76.304,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 522.095,
    cy: 82.127,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 528.777,
    cy: 88.226,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 535.207,
    cy: 94.591,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 541.373,
    cy: 101.211,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 547.267,
    cy: 108.076,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 552.877,
    cy: 115.174,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 558.194,
    cy: 122.493,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 563.211,
    cy: 130.022,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 567.919,
    cy: 137.748,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 572.309,
    cy: 145.658,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.376,
    cy: 153.74,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 580.111,
    cy: 161.98,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.51,
    cy: 170.364,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 586.566,
    cy: 178.88,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 589.274,
    cy: 187.512,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 591.631,
    cy: 196.247,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 593.631,
    cy: 205.07,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 595.272,
    cy: 213.967,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 596.552,
    cy: 222.923,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 597.467,
    cy: 231.924,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 598.017,
    cy: 240.955,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 605.222,
    cy: 259.045,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 604.69,
    cy: 268.077,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 602.563,
    cy: 286.043,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 600.973,
    cy: 294.949,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 599.034,
    cy: 303.786,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 596.75,
    cy: 312.54,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.023,
    cy: 362.578,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 571.448,
    cy: 370.384,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 566.571,
    cy: 378.003,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.398,
    cy: 385.426,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 555.937,
    cy: 392.639,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 550.198,
    cy: 399.633,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 503.003,
    cy: 441.571,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 495.384,
    cy: 446.448,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 487.578,
    cy: 451.023,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 479.599,
    cy: 455.288,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 471.459,
    cy: 459.236,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 347.919,
    cy: 478.803,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 338.957,
    cy: 477.563,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 330.051,
    cy: 475.973,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 246.997,
    cy: 441.571,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 239.574,
    cy: 436.398,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 232.361,
    cy: 430.937,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 225.367,
    cy: 425.198,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 212.083,
    cy: 412.917,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.812,
    cy: 406.396,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.802,
    cy: 399.633,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.063,
    cy: 392.639,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 178.552,
    cy: 370.384,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 173.977,
    cy: 362.578,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 146.197,
    cy: 277.081,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 145.31,
    cy: 268.077,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 144.778,
    cy: 259.045,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 144.6,
    cy: 250,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 144.778,
    cy: 240.955,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 145.31,
    cy: 231.923,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 146.197,
    cy: 222.919,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 147.437,
    cy: 213.958,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 149.027,
    cy: 205.051,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 150.966,
    cy: 196.214,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 153.25,
    cy: 187.46,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 155.877,
    cy: 178.802,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 158.841,
    cy: 170.255,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 162.138,
    cy: 161.83,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 165.764,
    cy: 153.541,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 169.712,
    cy: 145.401,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 173.977,
    cy: 137.422,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 178.552,
    cy: 129.616,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 183.429,
    cy: 121.997,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.602,
    cy: 114.574,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.063,
    cy: 107.361,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.802,
    cy: 100.367,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.812,
    cy: 93.604,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 212.083,
    cy: 87.083,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 218.604,
    cy: 80.812,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 225.367,
    cy: 74.802,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 232.361,
    cy: 69.063,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 239.574,
    cy: 63.602,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 411.043,
    cy: 22.437,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 510.426,
    cy: 63.602,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 517.639,
    cy: 69.063,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 524.633,
    cy: 74.802,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 531.396,
    cy: 80.812,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 537.917,
    cy: 87.083,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 544.188,
    cy: 93.604,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 550.198,
    cy: 100.367,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 555.937,
    cy: 107.361,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.398,
    cy: 114.574,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 566.571,
    cy: 121.997,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 571.448,
    cy: 129.616,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.023,
    cy: 137.422,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 580.288,
    cy: 145.401,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 584.236,
    cy: 153.541,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 587.862,
    cy: 161.83,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 591.159,
    cy: 170.255,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 594.123,
    cy: 178.802,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 596.75,
    cy: 187.46,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 599.034,
    cy: 196.214,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 600.973,
    cy: 205.051,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 602.563,
    cy: 213.958,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.803,
    cy: 222.919,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 604.69,
    cy: 231.923,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.051,
    cy: 277.084,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 608.306,
    cy: 294.966,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 606.425,
    cy: 303.816,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 592.058,
    cy: 346.641,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 588.222,
    cy: 354.834,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 584.076,
    cy: 362.876,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 579.627,
    cy: 370.753,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 574.882,
    cy: 378.456,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 569.846,
    cy: 385.973,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 564.529,
    cy: 393.292,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 558.936,
    cy: 400.404,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 512.822,
    cy: 443.543,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 505.353,
    cy: 448.65,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 497.696,
    cy: 453.469,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 489.861,
    cy: 457.992,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 481.859,
    cy: 462.214,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 473.703,
    cy: 466.129,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 465.403,
    cy: 469.73,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 332.257,
    cy: 483.724,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 323.39,
    cy: 481.927,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 314.598,
    cy: 479.794,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 240.888,
    cy: 446.132,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 233.519,
    cy: 440.884,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 219.405,
    cy: 429.566,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.194,
    cy: 417.207,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.95,
    cy: 410.659,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 193.961,
    cy: 403.878,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.234,
    cy: 396.875,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 172.709,
    cy: 374.627,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 168.111,
    cy: 366.836,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 139.507,
    cy: 281.574,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 138.476,
    cy: 272.585,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 137.788,
    cy: 263.564,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 137.443,
    cy: 254.524,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 137.443,
    cy: 245.476,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 137.788,
    cy: 236.436,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 138.476,
    cy: 227.415,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 139.507,
    cy: 218.426,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 140.88,
    cy: 209.484,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 142.592,
    cy: 200.6,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 144.641,
    cy: 191.788,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 147.024,
    cy: 183.06,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 149.738,
    cy: 174.43,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 152.779,
    cy: 165.909,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 156.141,
    cy: 157.509,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.821,
    cy: 149.244,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 163.813,
    cy: 141.125,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 168.111,
    cy: 133.164,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 172.709,
    cy: 125.373,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 177.6,
    cy: 117.762,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 182.778,
    cy: 110.342,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.234,
    cy: 103.125,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 193.961,
    cy: 96.122,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.95,
    cy: 89.341,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.194,
    cy: 82.793,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 212.682,
    cy: 76.488,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 219.405,
    cy: 70.434,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 226.354,
    cy: 64.64,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 248.452,
    cy: 48.904,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 256.2,
    cy: 44.232,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 264.12,
    cy: 39.859,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 404.33,
    cy: 14.217,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 413.285,
    cy: 15.505,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 422.185,
    cy: 17.132,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 505.353,
    cy: 51.35,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 512.822,
    cy: 56.457,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 540.592,
    cy: 79.609,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 546.959,
    cy: 86.037,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 553.077,
    cy: 92.703,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 558.936,
    cy: 99.596,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 564.529,
    cy: 106.708,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 569.846,
    cy: 114.027,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 574.882,
    cy: 121.544,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 579.627,
    cy: 129.247,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 584.076,
    cy: 137.124,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 588.222,
    cy: 145.166,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 592.058,
    cy: 153.359,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 595.58,
    cy: 161.693,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 598.782,
    cy: 170.155,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 601.66,
    cy: 178.732,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 604.209,
    cy: 187.413,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 606.425,
    cy: 196.184,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 608.306,
    cy: 205.034,
    r: 0.339
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 609.849,
    cy: 213.949,
    r: 0.339
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.051,
    cy: 222.916,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.911,
    cy: 231.922,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 618.297,
    cy: 277.088,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 617.13,
    cy: 286.059,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 615.632,
    cy: 294.982,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 613.805,
    cy: 303.843,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.653,
    cy: 312.63,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 609.177,
    cy: 321.332,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.269,
    cy: 338.432,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 599.846,
    cy: 346.806,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 596.115,
    cy: 355.049,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 587.753,
    cy: 371.092,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.133,
    cy: 378.871,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 578.229,
    cy: 386.473,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 573.047,
    cy: 393.89,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 507.695,
    cy: 455.716,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 500.003,
    cy: 460.479,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 492.14,
    cy: 464.954,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 484.117,
    cy: 469.136,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 475.945,
    cy: 473.018,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 467.635,
    cy: 476.596,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 459.199,
    cy: 479.864,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 450.647,
    cy: 482.819,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 334.472,
    cy: 491.422,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 325.579,
    cy: 489.76,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 308.007,
    cy: 485.455,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 234.794,
    cy: 450.672,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 227.475,
    cy: 445.355,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.764,
    cy: 427.831,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.308,
    cy: 421.493,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.091,
    cy: 414.921,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.12,
    cy: 408.123,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 171.771,
    cy: 386.473,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 166.867,
    cy: 378.871,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 162.247,
    cy: 371.092,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 131.703,
    cy: 277.088,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.868,
    cy: 268.079,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.367,
    cy: 259.046,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.2,
    cy: 250,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.367,
    cy: 240.954,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.868,
    cy: 231.921,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 131.703,
    cy: 222.912,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 132.87,
    cy: 213.941,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 134.368,
    cy: 205.018,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 136.195,
    cy: 196.157,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 138.347,
    cy: 187.37,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 140.823,
    cy: 178.668,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 143.619,
    cy: 170.063,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 146.731,
    cy: 161.568,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 150.154,
    cy: 153.194,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 153.885,
    cy: 144.951,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 157.918,
    cy: 136.852,
    r: 1.178
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 162.247,
    cy: 128.908,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 166.867,
    cy: 121.129,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 171.771,
    cy: 113.527,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 176.953,
    cy: 106.11,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 182.405,
    cy: 98.89,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.12,
    cy: 91.877,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.091,
    cy: 85.079,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.308,
    cy: 78.507,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 206.764,
    cy: 72.169,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 213.45,
    cy: 66.074,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 242.305,
    cy: 44.284,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 249.997,
    cy: 39.521,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 257.86,
    cy: 35.046,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 265.883,
    cy: 30.864,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 274.055,
    cy: 26.982,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 282.365,
    cy: 23.404,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 406.579,
    cy: 7.245,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 415.528,
    cy: 8.578,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 424.421,
    cy: 10.24,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 507.695,
    cy: 44.284,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 515.206,
    cy: 49.328,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 561.88,
    cy: 91.877,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 567.595,
    cy: 98.89,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 573.047,
    cy: 106.11,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 578.229,
    cy: 113.527,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 583.133,
    cy: 121.129,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 587.753,
    cy: 128.908,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 592.082,
    cy: 136.852,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 596.115,
    cy: 144.951,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 599.846,
    cy: 153.194,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.269,
    cy: 161.568,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 606.381,
    cy: 170.063,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 609.177,
    cy: 178.668,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.653,
    cy: 187.37,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 613.805,
    cy: 196.157,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 618.297,
    cy: 222.912,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.131,
    cy: 231.921,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 622.95,
    cy: 294.996,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.083,
    cy: 312.67,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 613.958,
    cy: 330.02,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 610.931,
    cy: 338.546,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 607.601,
    cy: 346.958,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.97,
    cy: 355.245,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 600.045,
    cy: 363.397,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 595.829,
    cy: 371.402,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 486.372,
    cy: 476.054,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 478.186,
    cy: 479.906,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 469.867,
    cy: 483.462,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 452.872,
    cy: 489.666,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 444.219,
    cy: 492.307,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 318.925,
    cy: 495.682,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 310.142,
    cy: 493.511,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 301.443,
    cy: 491.026,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 228.714,
    cy: 455.194,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 221.443,
    cy: 449.81,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 207.503,
    cy: 438.278,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.852,
    cy: 432.144,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.426,
    cy: 425.776,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.233,
    cy: 419.18,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 165.942,
    cy: 390.708,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 161.026,
    cy: 383.113,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 156.386,
    cy: 375.346,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 124.014,
    cy: 272.589,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 123.365,
    cy: 263.565,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 123.041,
    cy: 254.524,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 123.041,
    cy: 245.476,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 123.365,
    cy: 236.435,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 124.014,
    cy: 227.411,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 124.987,
    cy: 218.416,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 126.282,
    cy: 209.462,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 127.897,
    cy: 200.56,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 129.831,
    cy: 191.722,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 132.081,
    cy: 182.959,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 134.644,
    cy: 174.282,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 137.517,
    cy: 165.703,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 140.696,
    cy: 157.233,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 144.177,
    cy: 148.882,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 147.956,
    cy: 140.661,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 152.027,
    cy: 132.582,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 156.386,
    cy: 124.654,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 161.026,
    cy: 116.887,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 165.942,
    cy: 109.292,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 171.128,
    cy: 101.878,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 176.576,
    cy: 94.655,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 182.28,
    cy: 87.633,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.233,
    cy: 80.82,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.426,
    cy: 74.224,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 200.852,
    cy: 67.856,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 243.813,
    cy: 34.84,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 251.621,
    cy: 30.269,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 259.588,
    cy: 25.982,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 267.704,
    cy: 21.984,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 275.958,
    cy: 18.279,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 284.339,
    cy: 14.873,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 292.838,
    cy: 11.77,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 417.769,
    cy: 1.656,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 426.656,
    cy: 3.351,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 435.476,
    cy: 5.364,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 510.028,
    cy: 37.229,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 517.579,
    cy: 42.213,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 524.946,
    cy: 47.465,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 570.603,
    cy: 91.118,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 576.18,
    cy: 98.242,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 581.498,
    cy: 105.562,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 586.55,
    cy: 113.067,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 591.329,
    cy: 120.749,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 595.829,
    cy: 128.598,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 600.045,
    cy: 136.603,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.97,
    cy: 144.755,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 607.601,
    cy: 153.042,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 610.931,
    cy: 161.454,
    r: 0.679
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 613.958,
    cy: 169.98,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 616.676,
    cy: 178.609,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.083,
    cy: 187.33,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 621.175,
    cy: 196.132,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 624.406,
    cy: 213.933,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 625.54,
    cy: 222.909,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 630.262,
    cy: 295.01,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 628.536,
    cy: 303.891,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 626.501,
    cy: 312.706,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 624.159,
    cy: 321.445,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 621.514,
    cy: 330.097,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 618.568,
    cy: 338.652,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 615.326,
    cy: 347.098,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.791,
    cy: 355.426,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 607.967,
    cy: 363.626,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.86,
    cy: 371.687,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 472.098,
    cy: 490.326,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 463.652,
    cy: 493.568,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 455.097,
    cy: 496.514,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 303.555,
    cy: 499.159,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 222.646,
    cy: 459.697,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 215.421,
    cy: 454.252,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 201.561,
    cy: 442.623,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 194.945,
    cy: 436.453,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.547,
    cy: 430.055,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 160.113,
    cy: 394.943,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 155.186,
    cy: 387.355,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 150.526,
    cy: 379.6,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 116.431,
    cy: 268.081,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 115.958,
    cy: 259.046,
    r: 0.679
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 115.8,
    cy: 250,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 115.958,
    cy: 240.954,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 116.431,
    cy: 231.919,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 117.22,
    cy: 222.906,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 118.323,
    cy: 213.926,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 119.738,
    cy: 204.99,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 121.464,
    cy: 196.109,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 123.499,
    cy: 187.294,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 125.841,
    cy: 178.555,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 128.486,
    cy: 169.903,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 131.432,
    cy: 161.348,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 134.674,
    cy: 152.902,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 138.209,
    cy: 144.574,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 142.033,
    cy: 136.374,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 146.14,
    cy: 128.313,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 150.526,
    cy: 120.4,
    r: 0.839
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 155.186,
    cy: 112.645,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 160.113,
    cy: 105.057,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 165.303,
    cy: 97.646,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 170.748,
    cy: 90.421,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 176.441,
    cy: 83.389,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 182.377,
    cy: 76.561,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 188.547,
    cy: 69.945,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 253.313,
    cy: 21.14,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 261.374,
    cy: 17.033,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 269.574,
    cy: 13.209,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 277.902,
    cy: 9.674,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 286.348,
    cy: 6.432,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 294.903,
    cy: 3.486,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 519.943,
    cy: 35.113,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 527.354,
    cy: 40.303,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 584.697,
    cy: 97.646,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 589.887,
    cy: 105.057,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 594.814,
    cy: 112.645,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 599.474,
    cy: 120.4,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.86,
    cy: 128.313,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 607.967,
    cy: 136.374,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.791,
    cy: 144.574,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 615.326,
    cy: 152.902,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 621.514,
    cy: 169.903,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 624.159,
    cy: 178.555,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 626.501,
    cy: 187.294,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 628.536,
    cy: 196.109,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 630.262,
    cy: 204.99,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.677,
    cy: 213.926,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 632.78,
    cy: 222.906,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 637.568,
    cy: 295.022,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 635.888,
    cy: 303.912,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.627,
    cy: 321.495,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 629.051,
    cy: 330.168,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 626.183,
    cy: 338.748,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 623.024,
    cy: 347.227,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.58,
    cy: 355.593,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 615.853,
    cy: 363.837,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.849,
    cy: 371.95,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 216.59,
    cy: 464.185,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 209.408,
    cy: 458.682,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 154.285,
    cy: 399.177,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 149.347,
    cy: 391.597,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 144.669,
    cy: 383.852,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 115.065,
    cy: 308.334,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 108.638,
    cy: 254.524,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 108.638,
    cy: 245.476,
    r: 0.918
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 108.946,
    cy: 236.434,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 109.56,
    cy: 227.408,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 110.48,
    cy: 218.407,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 111.705,
    cy: 209.443,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 113.234,
    cy: 200.526,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 115.065,
    cy: 191.666,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 117.196,
    cy: 182.873,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 119.624,
    cy: 174.158,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 122.347,
    cy: 165.53,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 125.361,
    cy: 156.999,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 128.663,
    cy: 148.576,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 132.249,
    cy: 140.27,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 136.115,
    cy: 132.09,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 140.256,
    cy: 124.046,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 144.669,
    cy: 116.148,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 149.347,
    cy: 108.403,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 154.285,
    cy: 100.823,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.478,
    cy: 93.414,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 164.919,
    cy: 86.186,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 170.603,
    cy: 79.147,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 271.488,
    cy: 4.533,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 279.883,
    cy: 1.159,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 522.298,
    cy: 28.026,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 529.75,
    cy: 33.156,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 537.024,
    cy: 38.536,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 587.832,
    cy: 89.777,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 593.15,
    cy: 97.096,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 598.216,
    cy: 104.592,
    r: 0.958
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 603.025,
    cy: 112.256,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 607.571,
    cy: 120.078,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.849,
    cy: 128.05,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 615.853,
    cy: 136.163,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.58,
    cy: 144.407,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 623.024,
    cy: 152.773,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 629.051,
    cy: 169.832,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.627,
    cy: 178.505,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 633.907,
    cy: 187.26,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 635.888,
    cy: 196.088,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 637.568,
    cy: 204.978,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 643.232,
    cy: 303.931,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 639.081,
    cy: 321.541,
    r: 0.679
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 636.571,
    cy: 330.233,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 633.776,
    cy: 338.838,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 630.697,
    cy: 347.345,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 627.339,
    cy: 355.746,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 623.704,
    cy: 364.032,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.798,
    cy: 372.192,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 217.864,
    cy: 473.976,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 210.544,
    cy: 468.658,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 203.405,
    cy: 463.101,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 148.457,
    cy: 403.412,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 143.508,
    cy: 395.837,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 108.698,
    cy: 312.77,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 106.768,
    cy: 303.931,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 101.55,
    cy: 240.954,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 101.998,
    cy: 231.918,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 102.745,
    cy: 222.901,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 103.79,
    cy: 213.914,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 105.132,
    cy: 204.967,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 106.768,
    cy: 196.069,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 108.698,
    cy: 187.23,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 110.919,
    cy: 178.459,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 113.429,
    cy: 169.767,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 116.224,
    cy: 161.162,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 119.303,
    cy: 152.655,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 122.662,
    cy: 144.254,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 126.296,
    cy: 135.968,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.202,
    cy: 127.808,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 134.376,
    cy: 119.781,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 138.813,
    cy: 111.896,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 143.508,
    cy: 104.163,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 148.457,
    cy: 96.588,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 153.653,
    cy: 89.182,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 159.091,
    cy: 81.951,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 164.765,
    cy: 74.905,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 524.645,
    cy: 20.951,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 532.136,
    cy: 26.024,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 539.456,
    cy: 31.342,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 590.909,
    cy: 81.951,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 596.347,
    cy: 89.182,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 601.543,
    cy: 96.588,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 606.492,
    cy: 104.163,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.187,
    cy: 111.896,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 615.624,
    cy: 119.781,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.798,
    cy: 127.808,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 623.704,
    cy: 135.968,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 627.339,
    cy: 144.254,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 630.697,
    cy: 152.655,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 652.164,
    cy: 295.043,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 650.569,
    cy: 303.949,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 648.688,
    cy: 312.799,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 646.522,
    cy: 321.583,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 644.075,
    cy: 330.294,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 641.349,
    cy: 338.92,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 638.346,
    cy: 347.455,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 635.07,
    cy: 355.888,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.524,
    cy: 364.212,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 204.509,
    cy: 473.117,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 197.409,
    cy: 467.509,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 142.629,
    cy: 407.646,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 137.671,
    cy: 400.078,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 132.959,
    cy: 392.354,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 102.36,
    cy: 317.2,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 100.336,
    cy: 308.382,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 98.598,
    cy: 299.503,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 94.528,
    cy: 236.434,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 95.111,
    cy: 227.405,
    r: 0.579
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 95.984,
    cy: 218.4,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 97.147,
    cy: 209.427,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 98.598,
    cy: 200.497,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 100.336,
    cy: 191.618,
    r: 0.859
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 102.36,
    cy: 182.8,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 104.666,
    cy: 174.052,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 107.253,
    cy: 165.382,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 110.118,
    cy: 156.8,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 113.258,
    cy: 148.315,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 116.67,
    cy: 139.936,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 120.35,
    cy: 131.671,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 124.294,
    cy: 123.528,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 128.498,
    cy: 115.517,
    r: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 132.959,
    cy: 107.646,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 137.671,
    cy: 99.922,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 142.629,
    cy: 92.354,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 147.828,
    cy: 84.95,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 153.263,
    cy: 77.717,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 534.513,
    cy: 18.906,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 541.875,
    cy: 24.165,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 599.484,
    cy: 81.312,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 604.801,
    cy: 88.631,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 609.881,
    cy: 96.118,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 614.716,
    cy: 103.765,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.303,
    cy: 111.563,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 623.636,
    cy: 119.506,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 627.711,
    cy: 127.583,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.524,
    cy: 135.788,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 635.07,
    cy: 144.112,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 638.346,
    cy: 152.545,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 644.075,
    cy: 169.706,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 657.899,
    cy: 303.966,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 656.064,
    cy: 312.825,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 651.565,
    cy: 330.349,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 648.904,
    cy: 338.997,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 645.974,
    cy: 347.557,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 642.776,
    cy: 356.02,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 639.313,
    cy: 364.379,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 205.718,
    cy: 482.997,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 191.422,
    cy: 471.908,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 136.801,
    cy: 411.88,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 131.834,
    cy: 404.318,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 96.048,
    cy: 321.623,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 93.936,
    cy: 312.825,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 92.101,
    cy: 303.966,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 89.271,
    cy: 213.904,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 92.101,
    cy: 196.034,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 93.936,
    cy: 187.175,
    r: 0.779
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 96.048,
    cy: 178.377,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 98.435,
    cy: 169.651,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 101.096,
    cy: 161.003,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 104.026,
    cy: 152.443,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 107.224,
    cy: 143.98,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 110.687,
    cy: 135.621,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 114.41,
    cy: 127.376,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 118.39,
    cy: 119.251,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 122.624,
    cy: 111.255,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 127.106,
    cy: 103.396,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 131.834,
    cy: 95.682,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 136.801,
    cy: 88.12,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 142.003,
    cy: 80.718,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 536.88,
    cy: 11.801,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 544.282,
    cy: 17.003,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 551.517,
    cy: 22.435,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 607.997,
    cy: 80.718,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 613.199,
    cy: 88.12,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 618.166,
    cy: 95.682,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 622.894,
    cy: 103.396,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 627.376,
    cy: 111.255,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.61,
    cy: 119.251,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 635.59,
    cy: 127.376,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 639.313,
    cy: 135.621,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 642.776,
    cy: 143.98,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 645.974,
    cy: 152.443,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 648.904,
    cy: 161.003,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 651.565,
    cy: 169.651,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 653.952,
    cy: 178.377,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 665.222,
    cy: 303.981,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 663.432,
    cy: 312.85,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 661.37,
    cy: 321.659,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 659.04,
    cy: 330.401,
    r: 0.539
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 656.443,
    cy: 339.068,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 653.581,
    cy: 347.651,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 650.458,
    cy: 356.142,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 647.076,
    cy: 364.534,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 643.438,
    cy: 372.818,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 199.661,
    cy: 487.485,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 192.466,
    cy: 482,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 185.442,
    cy: 476.298,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.973,
    cy: 416.114,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 125.997,
    cy: 408.558,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 92.226,
    cy: 334.745,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 89.761,
    cy: 326.039,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 87.565,
    cy: 317.262,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 85.639,
    cy: 191.578,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 87.565,
    cy: 182.738,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 89.761,
    cy: 173.961,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 92.226,
    cy: 165.255,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 94.955,
    cy: 156.63,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 97.948,
    cy: 148.092,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 101.201,
    cy: 139.649,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 104.712,
    cy: 131.311,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 108.476,
    cy: 123.083,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 112.49,
    cy: 114.975,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 116.751,
    cy: 106.994,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 121.255,
    cy: 99.147,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 125.997,
    cy: 91.442,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 130.973,
    cy: 83.886,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 546.679,
    cy: 9.856,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 553.958,
    cy: 15.23,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.135,
    cy: 72.846,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 616.453,
    cy: 80.166,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 621.544,
    cy: 87.645,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.027,
    cy: 103.053,
    r: 0.519
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 635.41,
    cy: 110.968,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 639.548,
    cy: 119.014,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 643.438,
    cy: 127.182,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 647.076,
    cy: 135.466,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 650.458,
    cy: 143.858,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 653.581,
    cy: 152.349,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 656.443,
    cy: 160.932,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 659.04,
    cy: 169.599,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 661.37,
    cy: 178.341,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 676.859,
    cy: 268.085,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 676.183,
    cy: 277.107,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 672.54,
    cy: 303.996,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 670.792,
    cy: 312.872,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 668.779,
    cy: 321.693,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 666.502,
    cy: 330.45,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 663.965,
    cy: 339.134,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 661.169,
    cy: 347.739,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 658.117,
    cy: 356.256,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 654.812,
    cy: 364.678,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 651.256,
    cy: 372.997,
    r: 0.978
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 647.453,
    cy: 381.206,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 193.614,
    cy: 491.96,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 186.457,
    cy: 486.426,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 179.468,
    cy: 480.68,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 125.145,
    cy: 420.348,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 120.161,
    cy: 412.797,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 86.035,
    cy: 339.134,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 83.498,
    cy: 330.45,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 81.221,
    cy: 321.693,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 74.763,
    cy: 213.895,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 75.978,
    cy: 204.93,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 81.221,
    cy: 178.307,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 83.498,
    cy: 169.55,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 86.035,
    cy: 160.866,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 88.831,
    cy: 152.261,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 91.883,
    cy: 143.744,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 95.188,
    cy: 135.322,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 98.744,
    cy: 127.003,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 102.547,
    cy: 118.794,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 106.594,
    cy: 110.702,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 115.405,
    cy: 94.899,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 549.067,
    cy: 2.722,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 556.386,
    cy: 8.04,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 614.22,
    cy: 65.015,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 619.647,
    cy: 72.254,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 624.855,
    cy: 79.652,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 639.119,
    cy: 102.735,
    r: 0.459
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 643.406,
    cy: 110.702,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 647.453,
    cy: 118.794,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 651.256,
    cy: 127.003,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 654.812,
    cy: 135.322,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 658.117,
    cy: 143.744,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 661.169,
    cy: 152.261,
    r: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 663.965,
    cy: 160.866,
    r: 0.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 666.502,
    cy: 169.55,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 684.468,
    cy: 259.047,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 684.071,
    cy: 268.085,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 679.853,
    cy: 304.009,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 678.144,
    cy: 312.894,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 673.953,
    cy: 330.494,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 671.473,
    cy: 339.195,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 668.74,
    cy: 347.82,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 665.757,
    cy: 356.362,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 662.524,
    cy: 364.812,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 659.047,
    cy: 373.165,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 655.327,
    cy: 381.412,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 187.576,
    cy: 496.423,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 180.456,
    cy: 490.841,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 79.862,
    cy: 343.518,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 77.255,
    cy: 334.854,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 74.903,
    cy: 326.118,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 66.226,
    cy: 227.401,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 67.018,
    cy: 218.388,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 68.073,
    cy: 209.402,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 77.255,
    cy: 165.146,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 79.862,
    cy: 156.482,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 82.72,
    cy: 147.898,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 85.829,
    cy: 139.401,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 89.184,
    cy: 130.999,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 92.783,
    cy: 122.698,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 96.623,
    cy: 114.506,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 566.005,
    cy: 6.342,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 622.786,
    cy: 64.381,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 628.104,
    cy: 71.701,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 647.172,
    cy: 102.437,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 651.367,
    cy: 110.453,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 655.327,
    cy: 118.588,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 659.047,
    cy: 126.835,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 662.524,
    cy: 135.188,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 665.757,
    cy: 143.638,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 668.74,
    cy: 152.18,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 671.473,
    cy: 160.805,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 691.283,
    cy: 268.086,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 690.638,
    cy: 277.11,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 687.16,
    cy: 304.021,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 678.967,
    cy: 339.253,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 676.295,
    cy: 347.897,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 673.376,
    cy: 356.46,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 670.215,
    cy: 364.937,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 666.812,
    cy: 373.321,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 663.171,
    cy: 381.603,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 659.296,
    cy: 389.779,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 602.187,
    cy: 470.79,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 595.79,
    cy: 477.187,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 589.212,
    cy: 483.4,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 582.46,
    cy: 489.421,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 575.538,
    cy: 495.248,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 174.462,
    cy: 495.248,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 167.54,
    cy: 489.421,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 73.705,
    cy: 347.897,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 71.033,
    cy: 339.253,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 68.608,
    cy: 330.536,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 58.717,
    cy: 231.914,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 59.362,
    cy: 222.89,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 60.265,
    cy: 213.888,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 61.425,
    cy: 204.915,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 71.033,
    cy: 160.747,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 73.705,
    cy: 152.103,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 76.624,
    cy: 143.54,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 79.785,
    cy: 135.063,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 83.188,
    cy: 126.679,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 86.829,
    cy: 118.397,
    r: 0.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 631.297,
    cy: 63.79,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 659.296,
    cy: 110.221,
    r: 0.719
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 663.171,
    cy: 118.397,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 666.812,
    cy: 126.679,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 670.215,
    cy: 135.063,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 673.376,
    cy: 143.54,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 676.295,
    cy: 152.103,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 678.967,
    cy: 160.747,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 699,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 698.874,
    cy: 259.047,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 698.495,
    cy: 268.086,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 683.834,
    cy: 347.968,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 680.978,
    cy: 356.553,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 677.884,
    cy: 365.055,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 674.553,
    cy: 373.467,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 670.989,
    cy: 381.783,
    r: 0.898
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 667.194,
    cy: 389.996,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 663.171,
    cy: 398.1,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 649.768,
    cy: 421.694,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 611.186,
    cy: 471.793,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 604.901,
    cy: 478.301,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 598.437,
    cy: 484.632,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 591.798,
    cy: 490.779,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 584.991,
    cy: 496.738,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 168.475,
    cy: 499.646,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 67.564,
    cy: 352.27,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 64.828,
    cy: 343.646,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 51.284,
    cy: 236.432,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 51.789,
    cy: 227.399,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 52.546,
    cy: 218.383,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 64.828,
    cy: 156.354,
    r: 0.499
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 67.564,
    cy: 147.73,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 70.54,
    cy: 139.185,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 73.752,
    cy: 130.728,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 77.2,
    cy: 122.363,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 80.88,
    cy: 114.098,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 154.861,
    cy: 12.272,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 161.585,
    cy: 6.218,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 667.194,
    cy: 110.004,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 670.989,
    cy: 118.217,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 674.553,
    cy: 126.533,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 677.884,
    cy: 134.945,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 680.978,
    cy: 143.447,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 683.834,
    cy: 152.032,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 706.2,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 706.076,
    cy: 259.047,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 705.706,
    cy: 268.087,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 688.563,
    cy: 356.639,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 685.533,
    cy: 365.164,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 682.271,
    cy: 373.604,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 678.78,
    cy: 381.95,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 671.121,
    cy: 398.343,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 666.959,
    cy: 406.376,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 662.579,
    cy: 414.292,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 657.984,
    cy: 422.086,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 653.178,
    cy: 429.752,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 613.943,
    cy: 479.347,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 607.589,
    cy: 485.788,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 601.062,
    cy: 492.053,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 594.366,
    cy: 498.137,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 61.437,
    cy: 356.639,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 58.642,
    cy: 348.035,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 43.924,
    cy: 240.953,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 44.294,
    cy: 231.913,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 44.912,
    cy: 222.887,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 58.642,
    cy: 151.965,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 61.437,
    cy: 143.361,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 64.467,
    cy: 134.836,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 67.729,
    cy: 126.396,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 71.22,
    cy: 118.05,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 96.822,
    cy: 70.248,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 101.836,
    cy: 62.717,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 107.054,
    cy: 55.326,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 142.411,
    cy: 14.212,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 155.634,
    cy: 1.863,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 675.063,
    cy: 109.801,
    r: 0.599
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 678.78,
    cy: 118.05,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 682.271,
    cy: 126.396,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 685.533,
    cy: 134.836,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 688.563,
    cy: 143.361,
    r: 0.878
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 706.076,
    cy: 240.953,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 713.4,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 713.279,
    cy: 259.047,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 712.916,
    cy: 268.087,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 682.905,
    cy: 390.389,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 674.961,
    cy: 406.646,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 670.666,
    cy: 414.609,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 666.16,
    cy: 422.454,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 661.445,
    cy: 430.176,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 656.526,
    cy: 437.77,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 55.324,
    cy: 361.004,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 52.471,
    cy: 352.418,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 36.63,
    cy: 254.524,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 36.63,
    cy: 245.476,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 36.872,
    cy: 236.432,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 37.356,
    cy: 227.397,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 49.848,
    cy: 156.241,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 52.471,
    cy: 147.582,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 55.324,
    cy: 138.996,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 58.406,
    cy: 130.49,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 61.714,
    cy: 122.069,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 65.246,
    cy: 113.739,
    r: 0.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 77.16,
    cy: 89.358,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 81.561,
    cy: 81.453,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 86.172,
    cy: 73.669,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 90.989,
    cy: 66.01,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 96.009,
    cy: 58.484,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 101.229,
    cy: 51.093,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 143.02,
    cy: 3.627,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 682.905,
    cy: 109.611,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 686.548,
    cy: 117.892,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 689.968,
    cy: 126.268,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 693.164,
    cy: 134.733,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 696.131,
    cy: 143.28,
    r: 0.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 713.279,
    cy: 240.953,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 720.6,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 708.824,
    cy: 339.448,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 697.645,
    cy: 373.852,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 694.293,
    cy: 382.255,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 690.721,
    cy: 390.568,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 686.933,
    cy: 398.785,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 682.932,
    cy: 406.899,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 678.719,
    cy: 414.906,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 674.298,
    cy: 422.8,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 669.672,
    cy: 430.576,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 49.223,
    cy: 365.364,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 46.315,
    cy: 356.796,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 29.518,
    cy: 259.047,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 29.4,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 29.518,
    cy: 240.953,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 29.874,
    cy: 231.913,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 38.949,
    cy: 169.321,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 41.176,
    cy: 160.552,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 43.632,
    cy: 151.844,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 46.315,
    cy: 143.204,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 49.223,
    cy: 134.636,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 52.355,
    cy: 126.148,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 55.707,
    cy: 117.745,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 59.279,
    cy: 109.432,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 63.067,
    cy: 101.215,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 67.068,
    cy: 93.101,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 71.281,
    cy: 85.094,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 75.702,
    cy: 77.2,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 80.328,
    cy: 69.424,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 85.155,
    cy: 61.773,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 90.182,
    cy: 54.25,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 95.404,
    cy: 46.861,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 690.721,
    cy: 109.432,
    r: 0.479
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 694.293,
    cy: 117.745,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 697.645,
    cy: 126.148,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 700.777,
    cy: 134.636,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 703.685,
    cy: 143.204,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 720.126,
    cy: 231.913,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 720.482,
    cy: 240.953,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 716.262,
    cy: 339.489,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 708.374,
    cy: 365.454,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 705.304,
    cy: 373.965,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 702.016,
    cy: 382.394,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 698.514,
    cy: 390.736,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 694.798,
    cy: 398.986,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 690.873,
    cy: 407.137,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 46.313,
    cy: 378.19,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 43.134,
    cy: 369.72,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 40.173,
    cy: 361.17,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 22.461,
    cy: 263.568,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 22.229,
    cy: 254.524,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 22.229,
    cy: 245.476,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 32.619,
    cy: 164.894,
    r: 0.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 34.914,
    cy: 156.142,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 37.433,
    cy: 147.452,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 40.173,
    cy: 138.83,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 43.134,
    cy: 130.28,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 46.313,
    cy: 121.81,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 49.708,
    cy: 113.424,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 53.317,
    cy: 105.127,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 57.138,
    cy: 96.926,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 61.168,
    cy: 88.825,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 65.404,
    cy: 80.831,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 69.844,
    cy: 72.947,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 74.484,
    cy: 65.181,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 694.798,
    cy: 101.014,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 698.514,
    cy: 109.264,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 702.016,
    cy: 117.606,
    r: 0.819
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 705.304,
    cy: 126.035,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 708.374,
    cy: 134.546,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 726.756,
    cy: 222.883,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 727.336,
    cy: 231.912,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 727.684,
    cy: 240.953,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 718.751,
    cy: 356.935,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 715.955,
    cy: 365.54,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 712.944,
    cy: 374.071,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 709.72,
    cy: 382.525,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 706.283,
    cy: 390.895,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 83.754,
    cy: 461.603,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 78.528,
    cy: 454.217,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 40.28,
    cy: 382.525,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 37.056,
    cy: 374.071,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 15.455,
    cy: 268.088,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 15.114,
    cy: 259.047,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 15,
    cy: 250,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 24.17,
    cy: 169.263,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 26.31,
    cy: 160.472,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 28.67,
    cy: 151.737,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 31.249,
    cy: 143.065,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 34.045,
    cy: 134.46,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 37.056,
    cy: 125.929,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 40.28,
    cy: 117.475,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 43.717,
    cy: 109.105,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 47.362,
    cy: 100.825,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 51.214,
    cy: 92.638,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 55.271,
    cy: 84.551,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 59.53,
    cy: 76.569,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 706.283,
    cy: 109.105,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 709.72,
    cy: 117.475,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 712.944,
    cy: 125.929,
    r: 1.018
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 715.955,
    cy: 134.46,
    r: 0.799
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 733.182,
    cy: 213.87,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 733.977,
    cy: 222.882,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 734.545,
    cy: 231.912,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 728.795,
    cy: 348.312,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 726.265,
    cy: 356.998,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 723.522,
    cy: 365.62,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 720.568,
    cy: 374.172,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 717.404,
    cy: 382.648,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 706.672,
    cy: 407.573,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 77.929,
    cy: 465.835,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 72.702,
    cy: 458.45,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 34.256,
    cy: 386.856,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 30.988,
    cy: 378.42,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 27.928,
    cy: 369.905,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 9.165,
    cy: 281.628,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 8.496,
    cy: 272.605,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 8.051,
    cy: 263.569,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 7.828,
    cy: 254.524,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 15.824,
    cy: 173.655,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 17.814,
    cy: 164.829,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 20.021,
    cy: 156.055,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 22.443,
    cy: 147.337,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 25.08,
    cy: 138.682,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 27.928,
    cy: 130.095,
    r: 1.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 30.988,
    cy: 121.58,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 34.256,
    cy: 113.144,
    r: 1.038
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 37.732,
    cy: 104.79,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 41.412,
    cy: 96.525,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 714.032,
    cy: 108.956,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 717.404,
    cy: 117.352,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 720.568,
    cy: 125.828,
    r: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 723.522,
    cy: 134.38,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 740.418,
    cy: 213.867,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 741.197,
    cy: 222.881,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 741.754,
    cy: 231.912,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 736.249,
    cy: 348.358,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 733.767,
    cy: 357.058,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 731.076,
    cy: 365.696,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 728.176,
    cy: 374.266,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 718.247,
    cy: 399.522,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 714.534,
    cy: 407.773,
    r: 0.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 77.51,
    cy: 477.322,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 72.104,
    cy: 470.067,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 66.875,
    cy: 462.683,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 28.24,
    cy: 391.184,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 24.93,
    cy: 382.764,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 21.824,
    cy: 374.266,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 2.348,
    cy: 286.135,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 1.583,
    cy: 277.12,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 7.575,
    cy: 178.068,
    r: 0.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 11.479,
    cy: 160.4,
    r: 0.339
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 13.751,
    cy: 151.642,
    r: 1.158
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 16.233,
    cy: 142.942,
    r: 0.739
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 18.924,
    cy: 134.304,
    r: 1.078
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 21.824,
    cy: 125.734,
    r: 1.098
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 24.93,
    cy: 117.236,
    r: 1.118
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 28.24,
    cy: 108.816,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 666.91,
    cy: 15.556,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 672.49,
    cy: 22.678,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 677.896,
    cy: 29.933,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 718.247,
    cy: 100.478,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 721.76,
    cy: 108.816,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 725.07,
    cy: 117.236,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 746.67,
    cy: 204.871,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 747.652,
    cy: 213.865,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 748.417,
    cy: 222.88,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 741.258,
    cy: 357.114,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 735.769,
    cy: 374.356,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 732.719,
    cy: 382.874,
    r: 0.559
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 729.469,
    cy: 391.317,
    r: 0.419
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 726.019,
    cy: 399.681,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 722.371,
    cy: 407.961,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 71.684,
    cy: 481.555,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 66.279,
    cy: 474.299,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 61.048,
    cy: 466.917,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 5.165,
    cy: 155.977,
    r: 0.399
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 7.498,
    cy: 147.235,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 10.037,
    cy: 138.551,
    r: 0.679
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 12.782,
    cy: 129.93,
    r: 0.619
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 15.731,
    cy: 121.376,
    r: 0.938
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 18.881,
    cy: 112.895,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 675.55,
    cy: 14.866,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 681.04,
    cy: 22.057,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 726.019,
    cy: 100.319,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 729.469,
    cy: 108.683,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 740.352,
    cy: 382.977,
    r: 0.639
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 737.159,
    cy: 391.443,
    r: 0.319
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 65.857,
    cy: 485.788,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 60.454,
    cy: 478.531,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 55.222,
    cy: 471.15,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 3.856,
    cy: 134.165,
    r: 0.439
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 6.652,
    cy: 125.56,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 678.573,
    cy: 7.082,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 684.143,
    cy: 14.212,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 689.546,
    cy: 21.469,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 733.77,
    cy: 100.168,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 60.031,
    cy: 490.021,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 54.629,
    cy: 482.763,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 49.395,
    cy: 475.383,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 687.207,
    cy: 6.396,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 692.691,
    cy: 13.592,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 54.204,
    cy: 494.255,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 48.804,
    cy: 486.995,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 43.569,
    cy: 479.616,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 695.796,
    cy: 5.745,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 701.196,
    cy: 13.005,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 48.378,
    cy: 498.488,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 42.979,
    cy: 491.227,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 37.742,
    cy: 483.849,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 704.341,
    cy: 5.128,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 718.084,
    cy: 488.082,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 712.846,
    cy: 495.459,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 37.155,
    cy: 495.459,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 740.988,
    cy: 465.656,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 736.312,
    cy: 473.402,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 731.472,
    cy: 481.046,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 726.471,
    cy: 488.586,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 721.31,
    cy: 496.017,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 749.123,
    cy: 466,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 744.517,
    cy: 473.788,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 739.75,
    cy: 481.477,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 734.822,
    cy: 489.065,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 729.736,
    cy: 496.548,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 5.483,
    cy: 26.212,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 10.25,
    cy: 18.523,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 15.178,
    cy: 10.935,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 20.264,
    cy: 3.452,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 747.995,
    cy: 481.887,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 743.139,
    cy: 489.522,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 4.414,
    cy: 14.283,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 9.348,
    cy: 6.699,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#444444"
    },
    cx: 3.518,
    cy: 2.464,
    r: 0.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMap);
export default __webpack_public_path__ + "static/media/world-map.7063003492402f2f6075e1a193965af9.svg";
export { ForwardRef as ReactComponent };